export default __webpack_public_path__ + "static/media/pooja.2bf4185c.png";